import { render, staticRenderFns } from "./PerformanceApproval.vue?vue&type=template&id=1b467896&"
import script from "./PerformanceApproval.vue?vue&type=script&lang=js&"
export * from "./PerformanceApproval.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceApproval.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports